import {
  ReactElement, RefObject, useMemo, useRef,
  useState,
} from 'react';
import { Headers2 } from 'pages/Analysis/Header';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { getUserProfile } from 'helpers/userProfile';
import { useTranslation } from 'react-i18next';
import { EnergyConsumptionGoal } from './EnergyConsumptionGoal';
import { Helmet } from 'react-helmet';

interface ConsumptionGoalProps {
  clientId: number | undefined;
}

export function ConsumptionGoal({
  clientId,
}: Readonly<ConsumptionGoalProps>): ReactElement {
  const history = useHistory();
  const [profile] = useState(getUserProfile);
  const tabReference = useRef(null);
  const { t } = useTranslation();

  const queryPars = queryString.parse(history.location.search);
  const linkBase = history.location.pathname;

  const tabs = useMemo((): {
    title: string,
    link: string;
    isActive: boolean;
    visible: boolean,
    ref: RefObject<HTMLLIElement>
  }[] => ([
    {
      title: t('energia'),
      link: `${linkBase}?${queryString.stringify({ ...queryPars, meta: 'energia' })}`,
      isActive: (queryPars.meta === 'energia') || (!queryPars.meta),
      visible: !!profile.manageAllClients,
      ref: tabReference,
    },
  ]), [linkBase, profile.manageAllClients, queryPars]);

  return (
    <div>
      <Helmet>
        <title>{t('dielEnergiaEditarUnidade')}</title>
      </Helmet>
      <Headers2 links={tabs} />
      {tabs[0].isActive && clientId !== undefined && (
        <EnergyConsumptionGoal clientId={clientId} />
      )}
    </div>
  );
}
